import * as React from 'react';
import { useSelector } from 'react-redux';

import { ChatRemovalDate } from '../../components/ChatRemovalDate';
import { offerSelector, userIdSelector } from '../../selectors';

export const ChatRemovalDateContainer: React.FC = () => {
  const offer = useSelector(offerSelector);
  const userId = useSelector(userIdSelector);

  if (!offer?.removalFromPublicationDate) {
    return null;
  }

  // Не показываем надпись пользователю, разместившему объявление
  if (offer?.userId === userId) {
    return null;
  }

  return <ChatRemovalDate date={offer.removalFromPublicationDate} />;
};
